import {
  INDEX_ROUTE,
  LOGIN_ROUTE,
  EVENTS_ROUTE,
  EVENTS_ADD_ROUTE,
  EVENTS_EDIT_ROUTE,
  EVENTS_COPY_ROUTE,
  EVENTS_STATISTICS_ROUTE,
  EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,
  EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
  EVENTS_STATISTICS_PRODUCER_ROUTE,
  EVENTS_STATISTICS_GIFT_ROUTE,
  EVENTS_STATISTICS_LOYALTY_ROUTE,
  // STATISTICS_RRPP_ROUTE,
  TICKETS_ROUTE,
  TICKET_ADD_ROUTE,
  TICKET_EDIT_ROUTE,
  TICKET_TYPES_ROUTE,
  TICKET_TYPE_ADD_ROUTE,
  TICKET_TYPE_EDIT_ROUTE,
  USERS_ROUTE,
  ROLES_ROUTE,
  ROLES_ADD_ROUTE, 
  ROLES_EDIT_ROUTE,
  PLACES_ROUTE,
  PLACES_ADD_ROUTE,
  PLACES_EDIT_ROUTE,
  NOTIFICATIONS_ROUTE,
  NOTIFICATIONS_ADD_ROUTE,
  NOTIFICATIONS_EDIT_ROUTE,
  NEWS_ADD_ROUTE,
  NEWS_EDIT_ROUTE,
  NEWS_ROUTE,
  STATISTICS_ROUTE
} from "../config/RoutesConstants"
import Roles from "../config/RolesConstants"

let routesXRoles

function getRoutesXRoles(){
  if(!routesXRoles){
    routesXRoles = {}
    routesXRoles[Roles.SUPERADMIN] = [
      INDEX_ROUTE,
      LOGIN_ROUTE,
      EVENTS_ROUTE,
      EVENTS_ADD_ROUTE,
      EVENTS_EDIT_ROUTE,
      EVENTS_COPY_ROUTE,
      EVENTS_STATISTICS_ROUTE,
      EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,
      EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
      EVENTS_STATISTICS_PRODUCER_ROUTE,
      EVENTS_STATISTICS_GIFT_ROUTE,
      EVENTS_STATISTICS_LOYALTY_ROUTE,
      // STATISTICS_RRPP_ROUTE,
      TICKETS_ROUTE,
      TICKET_ADD_ROUTE,
      TICKET_EDIT_ROUTE,
      TICKET_TYPES_ROUTE,
      TICKET_TYPE_ADD_ROUTE,
      TICKET_TYPE_EDIT_ROUTE,
      USERS_ROUTE,
      ROLES_ROUTE,
      ROLES_ADD_ROUTE, 
      ROLES_EDIT_ROUTE,
      PLACES_ROUTE,
      PLACES_ADD_ROUTE,
      PLACES_EDIT_ROUTE,
      NOTIFICATIONS_ROUTE,
      NOTIFICATIONS_ADD_ROUTE,
      NOTIFICATIONS_EDIT_ROUTE,
      NEWS_ADD_ROUTE,
      NEWS_EDIT_ROUTE,
      NEWS_ROUTE,
      STATISTICS_ROUTE
    ]
    routesXRoles[Roles.ADMIN] = [
      INDEX_ROUTE, LOGIN_ROUTE, USERS_ROUTE, ROLES_ROUTE, ROLES_ADD_ROUTE, ROLES_EDIT_ROUTE
    ]
    routesXRoles[Roles.PRODUCTOR] = [
      INDEX_ROUTE,
      LOGIN_ROUTE,
      EVENTS_ROUTE,
      EVENTS_ADD_ROUTE,
      EVENTS_EDIT_ROUTE,
      EVENTS_COPY_ROUTE,
      EVENTS_STATISTICS_ROUTE,
      EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,
      EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
      EVENTS_STATISTICS_PRODUCER_ROUTE,
      EVENTS_STATISTICS_GIFT_ROUTE,
      EVENTS_STATISTICS_LOYALTY_ROUTE,
      // STATISTICS_RRPP_ROUTE,
      TICKETS_ROUTE,
      TICKET_ADD_ROUTE,
      TICKET_EDIT_ROUTE,
      TICKET_TYPES_ROUTE,
      TICKET_TYPE_ADD_ROUTE,
      TICKET_TYPE_EDIT_ROUTE,
      PLACES_ROUTE,
      PLACES_ADD_ROUTE,
      PLACES_EDIT_ROUTE,
      NOTIFICATIONS_ROUTE,
      NOTIFICATIONS_ADD_ROUTE,
      NOTIFICATIONS_EDIT_ROUTE,
      STATISTICS_ROUTE
    ]  
    routesXRoles[Roles.REDIMIDOR] = []
    routesXRoles[Roles.RRPP] = []
    routesXRoles[Roles.DEFAULT] = []
  }
  return routesXRoles
}

export function validateAccess(roles, route){
  if(roles&&route){
    let rXr = getRoutesXRoles() 
    for(let i=0;i<roles.length;i++){
      let rol = roles[i]&&roles[i].id
      console.log("ROL", rol)
      if(rXr[rol].includes(route)){
        return true
      }
    }
  }
  return false
  
}




// WEBPACK FOOTER //
// ./src/common/ValidateAccess.js